import type { SuggestHitIconKind } from '@/gql/graphql';
import { Text } from '@/components/ui/Text';
import { SuggestHitIcon } from './icons/SuggestHitIcon';
import { cn } from '@/lib/cn';

/**
 * Renders the per-hit kind badge: server-supplied `kindLabel` text + lucide icon.
 * Design §6.3 / A60.10: kindLabel is always server-computed — never synthesised on FE.
 */
interface SuggestKindBadgeProps {
  kindLabel: string;
  iconKind: SuggestHitIconKind;
  className?: string;
}

export function SuggestKindBadge({
  kindLabel,
  iconKind,
  className,
}: SuggestKindBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 shrink-0',
        className,
      )}
    >
      <SuggestHitIcon iconKind={iconKind} size={11} className="text-primary" />
      <Text variant="label-sm" color="primary" as="span">
        {kindLabel}
      </Text>
    </span>
  );
}
